// @flow
import React from "react";
import {GreyOverlayContainer} from "./GreyOverlayStyle";
import {connect} from "react-redux";
import Alert from "./Alert/Alert";
import Screens from "../../Store/Views/screens";
import AwaitingDriver from "./AwaitingDriver/AwaitingDriver";
import Loading from "./Loading/Loading";

type ConnectedProps = {|
    showLoading: boolean,
    showAlert: boolean,
    awaitingDriver: boolean,
|}

const GreyOverlay = (props: ConnectedProps) => {
    return (
        <GreyOverlayContainer>
            {props.showLoading ? <Loading/> : null}
            {props.showAlert ? <Alert/> : null}
            {props.awaitingDriver ? <AwaitingDriver/> : null}
        </GreyOverlayContainer>
    );
};

const mapStateToProps = (state, props) => {
    return {
        showLoading: Screens.showLoading(state),
        showAlert: Screens.shouldShowAlert(state),
        awaitingDriver: Screens.shouldShowAwaitingForDriver(state),
    };
};
export default connect(mapStateToProps)(GreyOverlay);



// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/GreyOverlay.js